import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';

import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class WidgetsService {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {

  }

  /**
   * Get project weather
   */
  projectWeather(payload) {
    //const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.widgets}/weather`;
    // `{{domain}}/v2/widgets/weather?projectId=1&calendarDate=2016-06-19`
    return this.http.get(url, payload);
  }

  /**
   * Upload photos
   */
  uploadPhotos(projectId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/workers/photo_upload`;
    return this.http.post(url, payload);
  }

}

